// src/utils/click-tracking.ts
var trackClickAndRedirect = async (event, track) => {
  if (track) {
    const { href, target } = event.currentTarget;
    await track("global.url_redirect", {
      url: href
    });
    if (target !== "_blank") {
      event.preventDefault();
      setTimeout(() => window.location.href = href, 750);
    }
  }
};
export {
  trackClickAndRedirect
};
